import { Card, Spinner } from "components/common";
import ViewQuestion from "components/custom/questions/viewQuestion";
import React, { useCallback } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useGetQuestionDetailQuery } from "../apis";
import {
  useGetPageTopicsQuery,
  useGetSearchListingScriptTopicsQuery,
} from "features/script/api";
import { TagsWithPlus } from "components/custom";
import PageLayout from "components/common/pageLayout/pageLayout";
import UserActions from "features/quiz/takeQuiz/userActions";

const ViewScriptQuestion = () => {
  const params = useParams();

  const {
    data: question,
    isLoading,
    error,
    refetch,
  } = useGetQuestionDetailQuery(
    { questionId: params?.id },
    { skip: !params?.id, refetchOnMountOrArgChange: true }
  );

  const { data: allScripts } = useGetPageTopicsQuery("");
  const { data: allTopics } = useGetSearchListingScriptTopicsQuery();

  const findScript = (scripts) => {
    if (allScripts?.length && scripts?.length) {
      return allScripts
        .filter(
          (e) =>
            scripts.includes(e.editor_template_id) || scripts?.includes(e?._id)
        )
        ?.map((e) => e?.page_name);
    }
    return ["-"];
  };

  const findTopic = (topics) => {
    if (allTopics?.data?.length && topics?.length) {
      return allTopics?.data
        .filter((topic) => topics.includes(topic._id))
        ?.map((e) => e?.PageTopics);
    }
    return ["-"];
  };

  const renderQuestionOptions = useCallback(() => {
    const detail = question?.[0];
    const clean = (arr) => (arr || []).filter((v) => v && v !== "-");

    const rows = [
      {
        label: "Question ID",
        text: detail?.questionId,
      },
      {
        label: "Speciality",
        values: clean(detail?.speciality?.map((s) => s?.name)),
      },
      {
        label: "Scripts",
        values: clean(findScript(detail?.scripts)),
      },
      {
        label: "Explanations",
        values: clean(detail?.explanation?.map((e) => e?.title)),
      },
      {
        label: "Topics",
        values: clean(findTopic(detail?.topics)),
      },
    ];

    return (
      <div
        style={{
          marginTop: 28,
          border: "1px solid #ececec",
          borderRadius: 12,
          background: "#fff",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            padding: "13px 20px",
            borderBottom: "1px solid #f0f0f0",
            background: "#fafafa",
          }}
        >
          <span style={{ fontSize: 15, fontWeight: 700, color: "#2b2b2b" }}>
            Details
          </span>
        </div>
        {rows.map((row, index) => (
          <div
            key={row.label}
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 16,
              padding: "14px 20px",
              borderBottom:
                index < rows.length - 1 ? "1px solid #f5f5f5" : "none",
            }}
          >
            <span
              style={{
                flex: "0 0 130px",
                fontSize: 13,
                fontWeight: 600,
                color: "#6b7280",
                lineHeight: "26px",
              }}
            >
              {row.label}
            </span>
            <div
              style={{
                flex: 1,
                minWidth: 0,
                minHeight: 26,
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 6,
              }}
            >
              {row.text ? (
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#2b2b2b",
                    lineHeight: "26px",
                  }}
                >
                  {row.text}
                </span>
              ) : row.values?.length ? (
                <TagsWithPlus data={row.values} plusAfter={5} />
              ) : (
                <span
                  style={{ color: "#b0b0b0", fontSize: 14, lineHeight: "26px" }}
                >
                  —
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }, [allScripts, allTopics, question]);

  const detail = question?.[0];

  return (
    <PageLayout
      showSubMenu={false}
      backIcon
      label={
        <span style={{ fontSize: 18, fontWeight: 600, color: "#1d1b20" }}>
          Question Details
          {detail?.questionId ? ` · ${detail.questionId}` : ""}
        </span>
      }
      renderCustomActions={() =>
        detail ? (
          <UserActions
            question={detail}
            scriptId={detail?.scripts?.[0]}
            onUserAction={() => refetch()}
          />
        ) : null
      }
    >
      {isLoading ? (
        <Spinner />
      ) : error ? (
        "Error"
      ) : (
        <Card style={{ minHeight: "88vh", overflow: "auto" }}>
          <ViewQuestion
            scriptQuestions={[detail]}
            showBorder={false}
            showQuestionId={false}
            showUserActions={false}
          />
          {renderQuestionOptions()}
        </Card>
      )}
    </PageLayout>
  );
};

export default ViewScriptQuestion;
